import React from "react";
import theme from "theme";
import {
  Theme,
  Image,
  LinkBox,
  Text,
  Box,
  Section,
  Link,
  Icon,
  Button,
} from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import { FaInstagram, FaYoutube, FaLinkedin, FaTwitter } from "react-icons/fa";
import { useState, useEffect } from "react";
import { MdSearch } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux/es/exports";
import { getBrandProfile } from "redux/BrandDetails/bd-actions";
import { NavLink, useParams } from "react-router-dom";
import ContentUpdate from "components/CMS/ContentUpdate";
// import { addSingleBlog } from "redux/Blogs/blogs-reducer";
import { addSingleBlog } from "redux/Blogs/blogs-actions";
import { getAllBlogs } from "redux/Blogs/blogs-actions";
import {
  getCms,
  getElementById,
  getUser,
  setSelectedData,
} from "redux/CMS/cms-actions";
export default () => {
  let blogData = useSelector((state) => state.BlogDetails.Blog);
  let singleBlog = useSelector((state) => state.BlogDetails.addSingleBlog);
  let latestBlog = blogData.reverse();
  latestBlog.slice(0, 2);
  const [showElement, setShowElment] = useState(false);
  const dispatch = useDispatch();
  const [mounted, setMounted] = useState(false);
  let data = useSelector((state) => state.cms.pages["Blog Overview"]);
  let project = useSelector((state) => state.userDetails.project);
  const BrandDetails = useSelector((state) => state.brandDetails.brandProfile);
  const [selectedData, updateSelectedData] = useState("update");
  const [isShow, setIsShow] = useState(false);
  let brandProfile = useSelector((state) => state.brandDetails.brandProfile);
  let userData = useSelector((state) => state.cms.userData);
  const [openDialog, handleDisplay] = useState(false);
  const handleClose = () => {
    handleDisplay(false);
  };

  const handleShow = () => {
    setShowElment(!showElement);
    console.log(showElement, "check");
  };
  function showSingleBlog(data) {
    console.log("helloiam", data);
    dispatch(addSingleBlog(data));
  }
  const [counterOn, setCounterOn] = useState(false);

  useEffect(() => {
    console.log("single", singleBlog);
    dispatch(getBrandProfile());
    dispatch(getCms());
    dispatch(getAllBlogs(data));
    setMounted(true);
    dispatch(
      getBrandProfile({
        projectId: project._id,
        projectName: project.projectName,
      })
    );
  }, [dispatch, setMounted]);
  const openDialogBox = () => {
    handleDisplay(true);
  };

  async function isSideBarOpen(id) {
    if (token) {
      await updateSelectedData(id);
      // selectedData = id;
      setIsShow(true);

      console.log(isShow, selectedData, id, "show");
    }
  }

  function closeSidebar(value) {
    setIsShow(value);
    updateSelectedData("");
    // selectedData = "";
    dispatch(setSelectedData({}));
    console.log(selectedData, "show");
  }

  //-----------hide/show-------
  const { token } = useParams();

  if (token) {
    let cmsStyle = document.getElementsByClassName("hoverText");
    // console.log(cmsStyle, "cmsStyle");
    for (let i = 0; i < cmsStyle.length; i++) {
      cmsStyle[i].onClick = function () {
        return false;
      };
      cmsStyle[i].classList.add("hoverText1");
    }
  }
  //----------------hide/show-----------
  return (
    <Theme theme={theme}>
      <GlobalQuarklyPageStyles pageUrl={"index11"} />
      <Helmet>
        <title>Blog-overview</title>
        <meta
          name={"description"}
          content={"Web site created using quarkly.io"}
        />
        {/* <link
          rel={"shortcut icon"}
          href={require("../assets/images/Gostart_Favicon.jpeg")}
          type={"image/x-icon"}
        /> */}
      </Helmet>

      <Section
        padding="80px 0 30px 0"
        sm-padding="80px 0 0px 0"
        quarkly-title="Our Cohort"
        iphone14Pro-align-items="center"
        iphone14Pro-justify-content="center"
      >
        <Override
          slot="SectionContent"
          margin="0px 150px 0px 150px"
          iphone14Pro-margin="0px 16px 0px 16px"
          iphone14Pro-align-items="center"
        />
        <Box position="relative" margin="0px 0px 20px 0px">
          <Text
            margin="0px 0px 8px 0px"
            text-align="center"
            font="700 48px satoshi"
            color="--dark"
            iphone14Pro-font="700 24px satoshi"
            id="8160569453"
            className="hoverText fsize30"
            onClick={() => isSideBarOpen("8160569453")}
          >
            {data ? data["8160569453"] : " Our Cohort Selection Process"}
          </Text>

          <Text
            margin="0px 0px 0px 0px"
            text-align="center"
            font="400 20px satoshi"
            iphone14Pro-font="400 16px satoshi"
            id="7808913305"
            className="hoverText "
            onClick={() => isSideBarOpen("7808913305")}
          >
            {data
              ? data["7808913305"]
              : "  Identify the stage of your startup and let us help you provide the right mentorship and access to our pool of investors."}
          </Text>
        </Box>
      </Section>

      <Section
        quarkly-title="Features Blog"
        align-items="center"
        justify-content="center"
        sm-flex-direction="column"
      >
        <Override
          slot="SectionContent"
          display="flex"
          flex-direction="row-reverse"
          sm-justify-content="space-between"
          tablet-margin="0px 80px 0px 80px"
          sm-margin="0px 20px 0px 20px"
          justify-content="center"
          sm-display="block"
          margin="0px auto 0px auto"
          padding="0px 0px 70px 0px"
        />
        <Box
          md-border-width="0px"
          mdlus-border-width="0px"
          width="30%"
          sm-width="100%"
          md-width="40%"
          lg-width="40%"
        >
          <Text
            margin="0px 0px 12px 0px"
            className="hoverText fsize26 sm-fsize18 font-semibold"
            width="fit-content"
            id="6033187809"
            onClick={() => isSideBarOpen("6033187809")}
          >
            {data ? data["6033187809"] : "Moderation"}
          </Text>
          <Box
            display="grid"
            sm-grid-gap="24px"
            sm-grid-template-rows="repeat(1, 1fr)"
            sm-grid-template-columns="repeat(1, 1fr)"
            md-grid-gap="24px"
            md-padding="0px 0px 20px 0px"
            width="100%"
          >
            {latestBlog
              ? latestBlog.map((e) => {
                  return (
                    <Box
                      href="/blog-overview"
                      onClick={() => showSingleBlog(e)}
                      display="flex"
                      flex-direction="column"
                      md-width="100%"
                      margin="0px 0px 20px 0px"
                      padding="0px 0px 10px 0px"
                      id="6312825249"
                      className="bordb"
                    >
                      <Image
                        margin="0px 0px 15px 0px"
                        background="--color-lightD2"
                        height="150px"
                        md-height="120px"
                        src={process.env.REACT_APP_STORAGE_URL_2 + e.image}
                        object-fit="cover"
                        className="hoverText"
                        id="7897743992"
                        onClick={() => isSideBarOpen("7897743992")}
                      />
                      <Text
                        margin="5px 0px 0px 0px "
                        font="700 18px satoshi"
                        sm-width="100%"
                        width="100%"
                        className=" fsize18"
                        id="6292379918"
                        onClick={() => isSideBarOpen("6292379918")}
                      >
                        {e.title}
                      </Text>
                      <Text
                        margin="3px 0px 12px 0px"
                        font="--subText"
                        id="1742586622"
                        className="fsize12"
                      >
                        {new Date(e.postDate).toDateString()}
                      </Text>
                      <Text
                        margin="0px 0px 6px 0px"
                        font="400 16px satoshi"
                        sm-width="100%"
                        width="100%"
                        className=" line-clamp3"
                        id="7939522952"
                        onClick={() => isSideBarOpen("7939522952")}
                      >
                        <p dangerouslySetInnerHTML={{ __html: e.content }}></p>
                      </Text>
                    </Box>
                  );
                })
              : "no-data"}
          </Box>
        </Box>
        <Box
          width="80%"
          sm-width="100%"
          md-width="100%"
          sm-margin="0px 0px 0px 0px"
          margin="0px 40px 0px 0px"
          lg-width="60%"
        >
          {"  "}
          {/* <Text
            text-align="left"
            font="600 24px satoshi"
            sm-font="400 24px satoshi"
            color="--grey"
            margin="0px 0px 10px 0px"
            className="hoverText"
            id="1941920976"
            sm-text-align="center"
            onClick={() => isSideBarOpen("1941920976")}
          >
            {data ? data["1941920976"] : "  Blog"}
          </Text> */}
          {/* <Text
            text-align="left"
            font="normal 500 28px/1.2 satoshi"
            sm-font="normal 500 20px/1.2 satoshi"
            width="80%"
            margin="0px 0px 10px 0px"
            className="hoverText"
            id="4263839201"
            md-width="100%"
            md-height="fit-content"
            sm-text-align="center"
            sm-width="100%"
            onClick={() => isSideBarOpen("4263839201")}
          >
            {singleBlog ? singleBlog.title : "no-data"}
          </Text> */}
          <Box margin="0px 0px 24px 0px" width="100%">
            <Image
              src={
                singleBlog
                  ? process.env.REACT_APP_STORAGE_URL_2 + singleBlog.image
                  : "no-data"
              }
              display="block"
              width="100%"
              object-fit="cover"
              className="hoverText"
              id="9439308641"
              height="450px"
              sm-width="100%"
              sm-height="280px"
              lg-width="100%"
              onClick={() => isSideBarOpen("9439308641")}
            />
          </Box>

          <Box
            padding="15px 10px 0px 10px"
            margin="0px 0px 5px 0px"
            sm-margin="0px 0px 20px 0px"
            id="4633287099"
            sm-width="100%"
            grid-template-columns="repeat(, 1fr)"
            grid-gap="20px"
          >
            <div className="flex justify-between items-center w-full">
              <Text
                margin="0px 0px 5px 0px"
                font="normal 500 28px/1.2 satoshi"
                color="--dark"
                className=" font-semibold sm-fsize19 fsize30"
                sm-font="--h4"
              >
                {singleBlog ? singleBlog.title : "no-data"}
              </Text>

              <Text
                margin="10px 0px 0px 0px"
                sm-margin="5px 0px 0px 0px"
                font="--base"
                padding="0px 0px 0px 0px"
                color="--darkL2"
                md-font="--subText"
                id="4052229641"
                className="fsize13"
                tablat-margin="10px 0px 10px 0px"
              >
                {singleBlog
                  ? new Date(singleBlog.postDate).toDateString()
                  : "no-data"}
              </Text>
            </div>

            <Text
              margin="10px 0px 5px 0px"
              font="400 16px satoshi"
              color="--darkL2"
              id="3098186765"
            >
              <p dangerouslySetInnerHTML={{ __html: singleBlog.content }}></p>
            </Text>
          </Box>
        </Box>
      </Section>

      <ContentUpdate
        selectedElement={selectedData}
        isShow={isShow}
        closeSidebar={closeSidebar}
      />
      <RawHtml>
        <style place={"endOfHead"} rawKey={"642d4c818d8a1a00208a41b7"}>
          {
            ":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"
          }
        </style>
        <style place={"endOfHead"} rawKey={"642d7b6ed03661edcb4d214f"}>
          {
            "@font-face {\n  font-family: 'Satoshi';\n  src: url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Light.woff2') format('woff2'), url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Light.woff') format('woff'), url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Light.ttf') format('truetype');\n  font-weight: 300;\n  font-style: italic;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Satoshi';\n  src: url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Regular.woff2') format('woff2'), url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Regular.woff') format('woff'), url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Regular.ttf') format('truetype');\n  font-weight: 400;\n  font-style: italic;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Satoshi';\n  src: url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Medium.woff2') format('woff2'), url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Medium.woff') format('woff'), url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Medium.ttf') format('truetype');\n  font-weight: 500;\n  font-style: italic;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Satoshi';\n  src: url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Bold.woff2') format('woff2'), url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Bold.woff') format('woff'), url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Bold.ttf') format('truetype');\n  font-weight: 700;\n  font-style: italic;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Satoshi';\n  src: url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Black.woff2') format('woff2'), url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Black.woff') format('woff'), url('https://uploads.quarkly.io/642d4c818d8a1a00208a41b9/files/fonts/Satoshi-Black.ttf') format('truetype');\n  font-weight: 900;\n  font-style: italic;\n  font-display: swap;\n}"
          }
        </style>
      </RawHtml>
    </Theme>
  );
};
